<template>
  <div>
    <b-row>
      <b-col :cols="!detailMedicationVisible ? 12 : 6">
<!-- Medicmento  -->
        <b-form-group id="input-group-1" label="Tipo de producto:" label-for="input-reason">
          <base-select v-model="medicationCombo.selected" :options="medicationCombo.options" label="text" valueProp="value"></base-select>
        </b-form-group>
        <b-form-group id="input-group-2" label="Tipo de prescripción:" label-for="input-prescription" v-if="medicationCombo.selected == 1">
          <base-select v-model="prescriptionCombo.selected" label="text" :options="prescriptionCombo.options" :dataAttributes="[{ key: 'key', value: 'label'}]"></base-select>
        </b-form-group>
<!-- Medicmento presentación -->
        <b-form-group id="input-group-3" label="Medicamento:" label-for="input-medicament" v-if="medicationCombo.selected == 1 && prescriptionCombo.selected == 1">
          <vue-bootstrap-typeahead
            :data="medications"
            v-model="medicationSearch"
            :serializer="s => s.nombreComercial"
            :maxMatches="maxMatches"
            placeholder="Teclee el nombre del medicamento y se buscará en el vademecum"
            @hit="selectedMedication = $event"
            @input="onKeywordChanged">
            <template slot="suggestion" slot-scope="{ data, htmlText }">
              <!-- <b-row> -->
                <!-- <div class="col-sm-3">
                  <img class="" :src="data.urlImagenEnvase != null ? data.urlImagenEnvase : '/static/img/medicamento-generico.jpeg' " style="width: 40px; height: 40px;"/>
                </div> -->
                  <b-row cols="12">
                    <span v-html="htmlText"></span>
                  </b-row>
                  <b-row cols="12">
                    <b-col cols="6">
                      <small class="text-muted">{{'Laboratorio: ' + data.laboratorio.nombreComercializador }}</small>
                    </b-col>
                    <b-col cols="6">
                      <small class="text-muted">{{' Contenido: ' + data.unidadesContenido + ' ' + data.formafarmaceutica.nombreSimplificado }}</small>
                    </b-col>
                  </b-row>
              <!-- </b-row> -->
            </template>
          </vue-bootstrap-typeahead>
        </b-form-group>
<!-- Principio activo-->
        <b-form-group
          id="input-group-3"
          label="Principio Activo:"
          label-for="input-principioActivo"
          v-if="medicationCombo.selected == 1 && prescriptionCombo.selected == 2"
        >
          <vue-bootstrap-typeahead
            :data="desplegablePrincipiosActivos"
            v-model="principioActivoSearch"
            :serializer="s => s.nombre"
            :maxMatches="maxMatches"
            placeholder="Teclee el nombre del principio activo y se buscará en la base de datos"
            @hit="selectedMedication = $event"
            @input="onKeywordChanged"
          >
            <template slot="suggestion" slot-scope="{ htmlText }">
              <div class="row">
                <div class="col-sm">
                  <div class="row">
                    <span v-html="htmlText"></span>
                  </div>
                </div>
              </div>
            </template>
          </vue-bootstrap-typeahead>
        </b-form-group>
<!-- Producto sanitario -->
        <b-form-group id="input-group-4" label="Producto sanitario:" label-for="input-medicament" v-if="medicationCombo.selected == 2">
          <vue-bootstrap-typeahead
            :data="desplegableProductosSanitarios"
            v-model="productoSanitarioSearch"
            :serializer="s => s.nombre"
            :maxMatches="maxMatches"
            placeholder="Teclee el nombre del producto sanitario y se buscará en la base de datos"
            @hit="selectedMedication = $event"
            @input="onKeywordChanged">
            <template slot="suggestion" slot-scope="{ data, htmlText }">
              <div class="row">
                <div class="col-sm">
                  <div class="row">
                    <span v-html="htmlText"></span>
                  </div>
                </div>
              </div>
            </template>
          </vue-bootstrap-typeahead>
        </b-form-group>
<!-- Nutrición enteral -->
        <b-form-group id="input-group-5" label="Producto nutricional:" label-for="input-medicament" v-if="medicationCombo.selected == 3">
          <vue-bootstrap-typeahead
            :data="medications"
            v-model="medicationSearch"
            :serializer="s => s.nombreComercial"
            :maxMatches="maxMatches"
            placeholder="Teclee el nombre del producto nutricional y se buscará en el vademecum"
            @hit="selectedMedication = $event"
            @input="onKeywordChanged">
            <template slot="suggestion" slot-scope="{ data, htmlText }">
              <div class="row">
                <div class="col-sm">
                  <div class="row">
                    <span v-html="htmlText"></span>
                  </div>
                </div>
              </div>
            </template>
          </vue-bootstrap-typeahead>
        </b-form-group>
<!-- Fórmula magistral -->  
        <b-row cols="12" v-if="medicationCombo.selected == 4">
          <b-col class="mb-0">
            <label for="treatmentStartDate">Descripción de la fórmula:</label>
            <base-textarea class="mb-0" maxlength="40" :label="Formula" v-model="newMedication.formula" :rows=3 :maxRows=9 ></base-textarea>
          </b-col>
        </b-row>
<!-- Vacuna individualizada -->  
        <b-row cols="12" v-if="medicationCombo.selected == 5">
          <b-col>
            <label for="treatmentStartDate">Descripción de la vacuna:</label>
            <base-textarea class="mb-0" maxlength="40" :label="VacunaInd" v-model="newMedication.vaccine" :rows=3 :maxRows=9 ></base-textarea>
          </b-col>
        </b-row>
<!-- Datos dispensacion -->  
        <div class="row">
          <div class="col-6">
            <label for="dispensingDate">Fecha de dispensación:</label>
            <b-form-datepicker id="dispensingDate" placeholder="Seleccione una fecha" v-model="newMedication.dispensingDate" :locale="dateLocale" :date-format-options="dateFormatOptions"></b-form-datepicker>
          </div>
          <div class="col-6 pl-2">
            <label for="packagesNumber">Número de envases:</label>
            <base-spin-input id="packagesNumber" v-model="newMedication.packagesNumber" min="1" max="200" step="1" :readonly="medicationCombo.selected == 4 || medicationCombo.selected == 5"></base-spin-input>
          </div>
        </div>
       <div id="tratamiento"  v-if="medicationCombo.selected == 1">
        <b-row cols="6">
          <div class="col-6">
            <label for="doseNumber">Dosis por toma:</label>
            <base-spin-input id="doseNumber" v-model="newMedication.doseNumber" min="1" max="200" step="1"></base-spin-input>
          </div>
          <div class="col-6 pl-2">
            <label for="doseFrequencyNumber">Frecuencia:</label>
            <base-spin-input id="doseFrequencyNumber" v-model="newMedication.doseFrequencyNumber" min="1" max="200" step="1"></base-spin-input>
          </div>
        </b-row>
        <b-row cols="6">
          <div class="col-6">
              <b-form-select v-model="doseUnitMeasureSelected" :options="doseUnitMeasureOptions"></b-form-select>
          </div>
          <div class="col-6 pl-2">
            <b-form-select v-model="frequencyMeasureSelected" :options="frequencyMeasureOptions" class="m"></b-form-select>
          </div>       
        </b-row>
        </div>
        <b-row cols="6">
          <div class="col-6">
            <label for="treatmentStartDate">Inicio del tratamiento:</label>
            <b-form-datepicker class="form-group" id="treatmentStartDate" placeholder="Seleccione una fecha" v-model="newMedication.treatmentStartDate" :date-format-options="dateFormatOptions"></b-form-datepicker>
          </div>
          <div class="col-6 pl-2">
            <label for="treatmentEndDate">Fin del tratamiento:</label>
            <b-form-datepicker class="form-group" id="treatmentEndDate" placeholder="Seleccione una fecha" v-model="newMedication.treatmentEndDate" :date-format-options="dateFormatOptions"></b-form-datepicker>
          </div>
        </b-row>
        <b-row cols="12">
          <b-col>
            <label for="treatmentStartDate">Observaciones:</label>
            <base-textarea :label="Observaciones" v-model="newMedication.observations" :rows=3 :maxRows=9 ></base-textarea>
          </b-col>
        </b-row>
      </b-col>
<!-- Columna de Información -->
      <b-col id="medicationDetail" v-if="detailMedicationVisible" cols="6" class="pl-3">
        <label class="text-left">Información:</label>
        <b-link style="float:right" size="sm" @click="closeMedicationDetail" href="#" variant="secondary"
            align-h="end"
            ><b-icon font-scale="1" icon="x-square"></b-icon
          ></b-link>
          <b-card
            :title="selectedMedication.nombreComercial"
            :img-src="
              selectedMedication.urlImagenEnvase != null
                ? selectedMedication.urlImagenEnvase
                : '/static/img/medicamento-generico.jpeg'
            "
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2"
          >
            <b-card-text>
                <small
                  >Laboratorio:
                  {{
                    selectedMedication.laboratorio.nombreComercializador
                  }}</small>
                  <br/>
                <small
                  >Presentación:
                  {{
                    selectedMedication.unidadesContenido +
                      ' ' +
                      selectedMedication.formafarmaceutica.nombreSimplificado
                  }}</small
                >
                <br/>
              <small>Vias de administración:</small>
              <ul>
                <li
                  v-for="data in selectedMedication.formafarmaceutica
                    .viasAdministracion"
                  :key="data.codigo"
                >
                  {{ data.nombre }}
                </li>
              </ul>
              <small>Principios activos:</small>
              <ul>
                <li
                  v-for="data in selectedMedication.formafarmaceutica
                    .principiosActivos"
                  :key="data.codigo"
                >
                  {{ data.nombre }}
                </li>
              </ul>
                <small v-if="
                  selectedMedication.formafarmaceutica.excipientes.length > 0
                ">Excipientes:</small>
              <ul>
                <li
                  v-for="data in selectedMedication.formafarmaceutica
                    .excipientes"
                  :key="data.codigo"
                >
                  {{ data.nombre }}
                </li>
              </ul>
                <small v-if="
                  selectedMedication.conReceta ||
                    selectedMedication.psicotropo ||
                    selectedMedication.estupefaciente ||
                    selectedMedication.afectaConduccion ||
                    selectedMedication.trianguloNegro ||
                    selectedMedication.usoHospitalario
                ">Características:</small>
              <ul>
                <li v-if="selectedMedication.conReceta" class="text-danger">NECESITA RECETA</li>
                <li v-if="selectedMedication.psicotropo" class="text-danger blink_me">PSICOTROPO</li>
                <li v-if="selectedMedication.estupefaciente" class="text-danger blink_me">ESTUPEFACIENTE</li>
                <li v-if="selectedMedication.afectaConduccion" class="text-danger">AFECTA A LA CONDUCCIÓN</li>
                <li v-if="selectedMedication.trianguloNegro" class="text-danger">NECESITA SEGUIMIENTO ADICIONAL</li>
                <li v-if="selectedMedication.usoHospitalario" class="text-danger">USO HOSPITALARIO</li>
              </ul>
            </b-card-text>
            <div class="w-100 mt-4">
              <b-button size="sm" variant="outline-info" target="_blank" :href="selectedMedication.urlProspecto"><b-icon shift-v="5" font-scale="0.8" icon="box-arrow-up-right"></b-icon>Prospecto</b-button>
              <b-button size="sm" variant="outline-info" target="_blank" :href="selectedMedication.urlFichaTecnica"><b-icon shift-v="5" font-scale="0.8" icon="box-arrow-up-right"></b-icon>Fecha técnica</b-button>
          </div>
          </b-card>
        </b-col>
    </b-row>

  </div>
</template>

<script>
import { BIcon, BIconBoxArrowUpRight, BIconXSquare, BRow, BCol, BFormGroup, BFormSelect, BFormDatepicker, BFormSpinbutton, BLink, BCard, BFormTextarea, BButton } from 'bootstrap-vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from 'underscore'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import MomentTimezone from 'moment-timezone'
import vuetify from '@/plugins/vuetify'

Vue.use(VueMoment, {
  MomentTimezone
})

export default {
  name: 'prescription',
  components: {
    'base-select': () => import('@/components/base/forms/BaseSelect.vue'),
    'base-datepicker': () => import('@/components/base/forms/BaseDatepicker'),
    'base-textarea': () => import('@/components/base/forms/BaseTextarea.vue'),
    BIcon,
    BIconXSquare,
    BIconBoxArrowUpRight,
    BFormGroup,
    BFormSelect,
    BRow,
    BCol,
    BFormDatepicker,
    BFormSpinbutton,
    BLink,
    BCard,
    BFormTextarea,
    BButton,
    VueBootstrapTypeahead,
    vuetify
  },
  props: 'selectedMedication',
  data () {
    return {
      dateLocale: 'es-ES',
      medicationCombo: {
        selected: 1,
        filterable: false,
        searchable: false,
        options: [
        { value: '1', text: 'Medicamento' },
        { value: '2', text: 'Producto Sanitario' },
        { value: '3', text: 'Nutrición enteral y dieto terapeutico' },
        { value: '4', text: 'Fórmula magistral' },
        { value: '5', text: 'Vacuna individualizada' }
        ]
      },
      prescriptionCombo: {
        selected: 1,
        filterable: false,
        searchable: false,
        options: [
        { value: '1', text: 'Por presentación' },
        { value: '2', text: 'Por principio activo' }
        ]
      },
      doseUnitMeasureSelected: 1,
      doseUnitMeasureOptions: [
        { value: '1', text: 'Cápsula' },
        { value: '2', text: 'Pastilla' }
      ],
      frequencyMeasureSelected: 1,
      frequencyMeasureOptions: [
        { value: '1', text: 'Horas' },
        { value: '2', text: 'Días' },
        { value: '3', text: 'Semanas' },
        { value: '4', text: 'Meses' }
      ],
      desplegableProductosSanitarios: [],
      desplegablePrincipiosActivos: [],
      productoSanitarioSearch: '',
      principioActivoSearch: '',
      medicationSearch: '',
      princpioActivoSearch: '',
      detailMedicationVisible: false,
      selectedMedication: {},
      isSelectedMedication: false,
      newMedication: null,
      maxMatches: 100,
      dateFormatOptions: { day: 'numeric', month: 'numeric', year: 'numeric' }
    }
  },
  mounted () {
  },
  created () {
    this.cleanMedicationForm()
  },
  methods: {
    async getMedication (query) {
      this.$nodofarmaApi.get('/Medicamento/GetByNombre', {
        params: {
          nombre: query
        }
      }).then((response) => {
        const suggestions = response.data
        if (suggestions.data !== null) {
          this.medications = suggestions.data
        }
      })
    },
    getProductoSanitario (query) {
      this.$nodofarmaApi.get('/ProductoSanitario/GetByNombre', {
        params: {
          nombre: query
        }
      }).then((response) => {
        const suggestions = response.data
        if (suggestions.data !== null) {
          this.desplegableProductosSanitarios = suggestions.data
        }
      })
    },
    getPrincipioActivo (query) {
      this.$nodofarmaApi.get('/PrincipioActivo/GetByNombre', {
        params: {
          nombre: query
        }
      }).then((response) => {
        const suggestions = response.data
        if (suggestions.data !== null) {
          this.desplegablePrincipiosActivos = suggestions.data
        }
      })
    },
    onKeywordChanged (event) {
      if (this.isSelectedMedication) {
        this.cleanMedicationForm()
      }
    },
    closeMedicationDetail () {
      this.detailMedicationVisible = false
    },
    cleanMedicationForm () {
      this.closeMedicationDetail()
      this.newMedication = this.newMedicationClear()
    },
    newMedicationClear () {
      return {
        medicationCombo: 1,
        dispensingDate: this.$moment(new Date()).format('YYYY-MM-DD'),
        treatmentStartDate: this.$moment(new Date()).format('YYYY-MM-DD'),
        treatmentEndDate: this.$moment(new Date())
          .add(7, 'days')
          .format('YYYY-MM-DD'),
        observations: null,
        doseNumber: 1,
        doseUnity: null,
        doseFrequencyNumber: 8,
        frequencyUnity: 1,
        packagesNumber: 1
      }
    },
    checkFillPrescription () {}
  },
  watch: {
    selectedMedication: function (val) {
      if (this.selectedMedication !== 'undefined') {
        this.detailMedicationVisible = true
        this.isSelectedMedication = true
        this.newMedication.doseUnity = this.selectedMedication.formafarmaceutica.viasAdministracion[0].nombre
        this.newMedication.doseNumber = this.newMedication.packagesNumber
        this.newMedication.tradeName = this.selectedMedication.nombreComercial
        this.newMedication.images = this.selectedMedication.urlImagenEnvase != null ? this.selectedMedication.urlImagenEnvase : '/static/img/medicamento-generico.jpeg'
      } else {
        this.detailMedicationVisible = false
      }
    },
    medicationSearch: _.debounce(function (addr) {
      this.getMedication(addr)
    }, 500),
    productoSanitarioSearch: _.debounce(function (addr) {
      this.getProductoSanitario(addr)
    }, 500),
    principioActivoSearch: _.debounce(function (addr) {
      this.getPrincipioActivo(addr)
    }, 500)
  }
}
</script>

<style lang="less">
.card-title {
  font-size: 1rem;
}
p {
  margin-bottom: 0.2rem;
}
ul {
  margin-bottom: 0.4rem;
}
li {
  font-size: 80%;
  font-weight: 400;
}
.margin-nolabel {
  margin-top: 34px;
}

.vbt-autcomplete-list {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
.blink_me {
  animation: blinker 2s linear infinite;
  font-weight: bold;
}

@keyframes blinker {  
  50% { opacity: 0; }
}
</style>



// WEBPACK FOOTER //
// src/components/webapp/professional/prescription.vue